<template>
  <v-modal
    id="resource-media-edit"
    size="lg"
    @closed="$emit('closed')"
  >
    <modal-header>
      <modal-title>
        {{ $t('resource.media') }}
      </modal-title>
    </modal-header>

    <modal-body>
      <div class="resources-media-container">
        <div class="mb-16">
          <v-uploader
            ref="uploader"
            :afterUpload="onChange"
            route-prefix="api/s3"
            @removed="onChange"
          />
        </div>

        <div v-if="media.length > 0" class="d-flex justify-content-end">
          <v-button
            class="btn-icon w-fit"
            size="sm"
            variant="primary"
            @click="saveResourceMedia"
          >
            {{ $t('general.button.save') }}
            <v-icon icon="arrow-right" size="sm" space="ms-12"/>
          </v-button>
        </div>
      </div>
    </modal-body>
  </v-modal>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import VModal from '@/components/vendor/basic/modal/VModal.vue';
import ModalHeader from '@/components/vendor/basic/modal/ModalHeader.vue';
import ModalTitle from '@/components/vendor/basic/modal/ModalTitle.vue';
import ModalBody from '@/components/vendor/basic/modal/ModalBody.vue';
import useConcepts from '@/helpers/Concepts';
import useModalUtils from '@/helpers/ModalUtils';
import api from '@/api';
import VUploader from '@/components/vendor/upload/VUploader.vue';
import VButton from '@/components/vendor/basic/button/VButton.vue';
import VIcon from '@/components/vendor/basic/icon/VIcon.vue';
import Resource from '@/api/objects/Resource';

export default defineComponent({
  name: 'TheResourceMediaModal',
  components: {
    VUploader,
    ModalBody,
    ModalTitle,
    ModalHeader,
    VModal,
    VButton,
    VIcon,
  },
  emits: ['closed', 'emitReloadResource'],
  props: {
    resource: {
      type: Resource,
      required: true,
    },
  },
  setup() {
    return {
      ...useConcepts(),
      ...useModalUtils(),
    };
  },
  data() {
    return {
      media: [] as any,
    };
  },
  computed: {
    mediaUuids() {
      return this.media.map((media: any) => ({
        uuid: media.attributes.uuid,
        name: media.attributes.name,
      }));
    },
  },
  methods: {
    onChange() {
      const { uploader }: any = this.$refs;
      if (!!uploader) {
        this.media = uploader.mediaLibrary.state.media;
      }
    },
    async saveResourceMedia() {
      try {
        const data: any = {
          translations: this.resource.translations.map((translation) => ({ title: translation.title })),
          location_id: this.resource.locationId,
          types: JSON.parse(this.resource.types),
          type: this.resource.type,
          map_url: this.resource.mapUrl,
          address_1: this.resource.address1,
          address_2: this.resource.address2,
          postal_code: this.resource.postalCode,
          country: this.resource.country,
          city: this.resource.city,
          state: this.resource.state,
          lat: this.resource.lat,
          lng: this.resource.lng,
          site_url: this.resource.siteUrl,
          phone: this.resource.phone,
          images: this.mediaUuids,
          stage_length: this.resource.stageLength,
          destination: this.resource.destination,
        };

        await api.resource.update(this.resource.id, data);

        this.$toast.success(this.$t('general.shared.savedChanges'));

        this.$emit('emitReloadResource');
        this.$emit('closed');

        this.media = [];

        const { uploader }: any = this.$refs;

        if (!!uploader) {
          uploader.mediaLibrary.state.media = [];
        }
      } catch (e: any) {
        console.error(e.response.data);

        this.$toast.error(e.response.data.message);
      }
    },
  },
});
</script>
